import { render, staticRenderFns } from "./profile-circular-frame.vue?vue&type=template&id=307d0c13&"
import script from "./profile-circular-frame.vue?vue&type=script&lang=js&"
export * from "./profile-circular-frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307d0c13')) {
      api.createRecord('307d0c13', component.options)
    } else {
      api.reload('307d0c13', component.options)
    }
    module.hot.accept("./profile-circular-frame.vue?vue&type=template&id=307d0c13&", function () {
      api.rerender('307d0c13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profile-circular-frame.vue"
export default component.exports